// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__Ec_wO","isHidden":"Panel_isHidden__13V_8"};